import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { Video } from '../../types'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'
import { useDeleteVideo, useUpdateVideo, useVideo } from '../../hooks/video'
import VideoForm from '../../components/VideoForm'

export default function VideoEdit() {
  const { id } = useParams()
  const { data: dataVideo } = useVideo(+id!)
  const deleteVideo = useDeleteVideo()
  const updateVideo = useUpdateVideo()
  const [modalRm, modalRmActions] = useModalTrigger<Video>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/video">Video</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {dataVideo!.title}
            </li>
          </ol>
        </nav>
        <div className="d-flex align-items-center">
          <button
            className="btn btn-primary me-2"
            onClick={() => navigate(`/video/${dataVideo!.id}/annotations`)}
          >
            <i className="bi bi-list"></i> Schede
          </button>
          <button
            className="btn btn-danger"
            onClick={() => modalRmActions.open(dataVideo)}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </div>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <VideoForm
          video={dataVideo}
          save={(formVideo) =>
            updateVideo.mutateAsync(formVideo).then(() =>
              toast.success('Video salvato con successo!', {
                position: toast.POSITION.TOP_RIGHT,
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il video {modalRm.value.title} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn btn-danger"
            disabled={deleteVideo.isLoading}
            onClick={async () => {
              await deleteVideo.mutateAsync(modalRm.value!.id)
              navigate('/video')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
